import { render } from "./Formato2014.vue?vue&type=template&id=29993c7e&scoped=true"
import script from "./Formato2014.vue?vue&type=script&lang=js"
export * from "./Formato2014.vue?vue&type=script&lang=js"

import "./Formato2014.vue?vue&type=style&index=0&id=29993c7e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29993c7e"]])

export default __exports__